import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/babe-associate";


export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (values) => {
  return await axiosInstance(options).get(`${path}/details?_id=${values}`);
};

export const updateAssociate = async (values) => {
  return await axiosInstance(options).put(`${path}/update-user-associate`, values);
};

export const blockAssociate = async (values) => {
  return await axiosInstance(options).patch(`${path}/block-associate`, values);
};

export const Delete = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete?_id=${values._id}`);
}

export const ChangeStatus = async (values) => {
  return await axiosInstance(options).put(`${path}/change-status`, values);
}

export const ChangeVerification = async (values) => {
  return await axiosInstance(options).patch(`${path}/verify-associate`, values);
}

export const ChangeActivationStatus = async (values) => {
  return await axiosInstance(options).put(`${path}/change-activation-status`, values);
}

export const RejectVerificationRequest = async (values) => {
  return await axiosInstance(options).patch(`${path}/reject-verification-request`, values);
}

// export const ChangeLicenseVerification = async (values) => {
//   return await axiosInstance(options).patch(`${path}/verify-associate-license`, values);
// }

// export const RejectLicenseVerificationRequest = async (values) => {
//   return await axiosInstance(options).patch(`${path}/reject-license-verification-request`, values);
// }

export const ChangeMassageLicenseVerification = async (values) => {
  return await axiosInstance(options).patch(`${path}/verify-associate-massage-license`, values);
}

export const ChangeInjectionLicenseVerification = async (values) => {
  return await axiosInstance(options).patch(`${path}/verify-associate-injection-license`, values);
}

export const ChangeProfileLicenseVerification = async (values) => {
  return await axiosInstance(options).patch(`${path}/verify-associate-profile`, values);
}

export const UpdateNotes = async (values) => {
  return await axiosInstance(options).patch(`${path}/update-notes`, values);
}

export const LicenseChangeList = async (values) => {
  return await axiosInstance(options).post(`${path}/license-change-list`, values);
}






